import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { NomenclatureForm } from "src/enitities/Form";
import { ModalForm } from "src/enitities/Modal";
import { NomenclatureContext } from "src/shared/lib/hooks/context/getNomenclatureContext";
import { apiRequests } from "src/shared/api/api";

export default function EditNomenclature({
  record,
  handleSave,
  handleDeleteImage,
  handleSaveImage,
}) {
  const { unitsData, token } = useContext(NomenclatureContext);
  const [isOpen, setOpen] = useState(false);
  const [changeData, setChangeData] = useState(false);
  const [submitIsDisabled, setSubmitDisabled] = useState(false);
  const [fullRecord, setFullRecord] = useState(record);
  const [form] = Form.useForm();
  const handleSubmit = async (data) => {
    const unit = unitsData.filter((item) => item.id === data[0].unit);
    data[0].id = record.id;
    data[0].unit_name = unit[0]?.convent_national_view;

    // Подготавливаем полный payload, включая маркетплейс-поля
    const payload = data[0];

    try {
      // Основное сохранение через общий CRUD-эндпоинт
      const response = await handleSave(payload, "edit");
      setSubmitDisabled(true);

      // Дополнительно синхронизируем данные через mp-эндпоинт номенклатуры,
      // который отвечает в том числе за marketplace_price и chatting_percent
      try {
        await apiRequests.nomenclature.patch([payload]);
      } catch (syncError) {
        // Не блокируем основное сохранение, просто логируем
        console.error("Error syncing marketplace fields for nomenclature:", syncError);
      }
      
      // Возвращаем данные из ответа API для обновления формы
      // handleSave возвращает axios response, где данные в response.data
      // Проверяем различные варианты структуры ответа
      if (response?.data) {
        // Если это axios response с данными
        // Проверяем, есть ли вложенный result
        if (response.data.result && typeof response.data.result === "object") {
          // Данные могут быть в response.data.result
          return { ...response, data: response.data.result };
        }
        // Или данные напрямую в response.data
        return response;
      } else if (response && typeof response === "object" && !response.status) {
        // Если это уже объект данных (не axios response)
        return response;
      } else {
        // Возвращаем весь response
        return response;
      }
    } catch (err) {
      return Promise.reject(err.response?.data.detail[0].msg);
    }
  };

  // Функция для перезапроса полных данных после сохранения
  const refreshNomenclatureData = async () => {
    if (record?.id) {
      try {
        const response = await apiRequests.nomenclature.getItem(record.id, { token });
        const fullData = response.data;
        console.log("Refreshed nomenclature data after save:", fullData);
        
        setFullRecord(fullData);
        // Обновляем форму с новыми данными, включая qr_hash
        form.setFieldsValue(fullData);
      } catch (error) {
        console.error("Error refreshing nomenclature data:", error);
      }
    }
  };

  const handleIsChanges = () => {
    const formDataJSON = JSON.stringify(record);
    const currentDataJSON = JSON.stringify(form.getFieldValue());
    if (formDataJSON !== currentDataJSON) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  useEffect(() => {
    setSubmitDisabled(false);
    // При закрытии модального окна сбрасываем fullRecord
    if (!isOpen) {
      setFullRecord(null);
      return;
    }
    // При открытии модального окна получаем полные данные номенклатуры
    const loadData = async () => {
      try {
        const response = await apiRequests.nomenclature.getItem(record.id, { token });
        const fullData = response.data;
        setFullRecord(fullData);
        // Устанавливаем все значения в форму, включая qr_hash
        form.setFieldsValue(fullData);

      } catch (error) {
        console.error("Error fetching full nomenclature data:", error);
        // Если ошибка, используем данные из record
        setFullRecord(record);
        form.setFieldsValue(record);
      }
    };

    if (isOpen && record?.id) {
      loadData();
    } else if (isOpen && record) {
      // Если нет ID, просто используем record
      setFullRecord(record);
      form.setFieldsValue(record);
    }
  }, [isOpen, record, token, form]);

  return (
    <>
      <Tooltip title="Редактировать номенклатуру">
        <Button icon={<EditOutlined />} onClick={() => setOpen(true)} />
      </Tooltip>
      {isOpen ? (
        <ModalForm
          formContext={form}
          width={1000}
          title={"Редактировать номенклатуру"}
          isOpen={isOpen}
          setOpen={setOpen}
          handleSubmit={handleSubmit}
          submitIsDisabled={submitIsDisabled}
          changeData={changeData}
          setChangeData={setChangeData}
          onAfterSave={refreshNomenclatureData}
        >
          <NomenclatureForm
            record={fullRecord || record}
            formContext={form}
            handleDeleteImage={handleDeleteImage}
            handleSaveImage={handleSaveImage}
            handleIsChanges={handleIsChanges}
            setChangeData={setChangeData}
          />
        </ModalForm>
      ) : (
        false
      )}
    </>
  );
}
